import styles from "./MainContent.module.scss";
import { ParallaxProvider } from "react-scroll-parallax";
import { Parallax } from "react-scroll-parallax";
import Description from "../Description/Description";
import Hero from "../Hero/Hero";
import Advantages from "../Advantages/Advantages";
import ChargingMethods from "../ChargingMethods/ChargingMethods";
// import News from "../News/News";
import Contacts from "../Contacts/Contacts";
import MobileApp from "../MobileApp/MobileApp";
import Specifications from "../Specifications/Specifications";
import MediaQuery from "react-responsive";
import devider from "../../static/images/devider.jpg";
import devider_mobile from "../../static/images/devider_mobile.jpg";

export default function MainContent() {
  return (
    <>
      <main>
        <ParallaxProvider>
          <Parallax speed={-40}>
            <Hero />
          </Parallax>
        </ParallaxProvider>
        <div className={styles.content1}>
          <Description />
          <Advantages />
          <ChargingMethods />
          <Specifications />
          {/* <News /> */}
        </div>
        <ParallaxProvider>
          <div className={styles.devider}>
            <MediaQuery minWidth={1366}>
              <Parallax speed={20}>
                <img src={devider} alt="" />
              </Parallax>
            </MediaQuery>
            <MediaQuery maxWidth={1365}>
              <Parallax
                speed={9}
              >
                <img src={devider_mobile} alt="" />
              </Parallax>
            </MediaQuery>
          </div>
        </ParallaxProvider>
        <div className={styles.content2}>
          <Contacts />
          <MobileApp />
        </div>
        {/* <NewsPage />
        <CurrentNews></CurrentNews> */}
      </main>
    </>
  );
}
